export function validateBreakEma(data) {
  const { candleDuration, timeUnit, periodLengths } = data;
  if (candleDuration <= 0 || !Number.isInteger(candleDuration))
    return [false, 'Candle Duration must be a whole number larger than zero.'];
  if (timeUnit === 'default' || timeUnit === undefined)
    return [false, 'Please select a time unit.'];
  if (!periodLengths || periodLengths?.length === 0)
    return [false, 'You must enter at least one period.'];
  return [true, ''];
}

